// extracted by mini-css-extract-plugin
export default {"nav":"Snapshot_nav__vgxqv","item":"Snapshot_item__09qJN","active":"Snapshot_active__FdIKY"};